"use strict";

import $ from "jquery";
window.$ = window.jQuery = $;
import 'slick-carousel'

export class MiniSlider {
  constructor() {
    console.log("miniSlider module");
   
    (function( $ ) {
        // Use $ as usual here, e.g.:
        $(".js-section__entry__miniSlider").slick({
            infinite: true,
            slidesToShow: 1,
            dots: true,
            arrows: false,
            autoplay: true,
            fade: true,
            pauseOnFocus: true,
            pauseOnHover: false,
            autoplaySpeed: 3000,
        });
    })( jQuery );

  }
}
